import { mutatorAction } from "satcheljs";
import type { AccountSource, AdditionalAccountInfo, M365TeamRhythmAccountSource, M365UserMailboxAccountSource, LoadState, } from "../store/schema/AccountSourceList";
import setM365UserMailboxAdditionalSources from "../utils/setM365UserMailboxAdditionalSources";

function getTeamRhythmSources(account: M365UserMailboxAccountSource): AdditionalAccountInfo {
    return account.teamRhythmSources;
}

function updateTeamRhythmSources(account: M365UserMailboxAccountSource, loadState: LoadState, sources: AccountSource[]) {
    account.teamRhythmSources.loadState = loadState;
    account.teamRhythmSources.sources = sources;
}

const setTeamRhythmAccountMutator: (coprincipalSourceId: string, loadState: LoadState, sources: M365TeamRhythmAccountSource[] | undefined) => void = mutatorAction("SET_TEAMRHYTHM_ACCOUNTS", function (coprincipalSourceId: string, loadState: LoadState, sources: M365TeamRhythmAccountSource[] | undefined): void {
    setM365UserMailboxAdditionalSources("TeamRhythm", coprincipalSourceId, {
        coprincipalSourceId,
        loadState,
        sources: sources ? sources : [],
    }, getTeamRhythmSources, updateTeamRhythmSources);
});
export default setTeamRhythmAccountMutator;
